import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { IconESim, IconFire, IconInfinityConstructor, IconInfinityWhite, IconPresent, IconSettings, IconTimer, IconUserAdd } from "../../../../assets/IconsTariffTile";
var cn = classNames.bind({});
var icons = {
  infinityConstructor: IconInfinityConstructor,
  present: IconPresent,
  eSim: IconESim,
  fire: IconFire,
  infinityWhite: IconInfinityWhite,
  userAdd: IconUserAdd,
  timer: IconTimer,
  settings: IconSettings
};
export var Icon = /*#__PURE__*/memo(function (_ref) {
  var name = _ref.name,
    className = _ref.className;
  var IconComponent = icons[name];
  return /*#__PURE__*/React.createElement(IconComponent, {
    className: cn(className),
    "data-t-id": "components-Icon"
  });
});